import PropTypes from 'prop-types';
import React from 'react';
import { LabeledCheckbox } from 'components/shared/checkbox';

const AssignContent = ({ assignContent, setAssignContent }) => {
  return (
    <LabeledCheckbox
      label={t('in_person_training.event_content.assign_follow_up_content')}
      checked={assignContent}
      className="EditorElement-options"
      onChange={() => setAssignContent(!assignContent)}
    />
  );
};

AssignContent.propTypes = {
  assignContent: PropTypes.bool,
  setAssignContent: PropTypes.func.isRequired,
};

export default AssignContent;
